module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-b2aea369fef7a0483e9886c3c5b391cc.webp";